import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPostDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:9010/api'

export const getTest = () => {
  const url = `${API_ROOT}/proposal/dashboard`

  return doGet(url)
}

export const getTermsURL = (uid) => {
  // http://103.91.191.229:9000/api/identity/terms-url/{uid}
  const url = `${API_ROOT}/identity/terms-url/${uid}`

  return doGet(url)
}

export const getPrivacyURL = () => {
  // const API_ROOT = 'http://localhost:9010/api'
  const url = `${API_ROOT}/identity/privacy`

  return doGet(url)
}

export const getUserProfile = () => {
  const url = `${API_ROOT}/dashboard/user/loggedin`
  return doGet(url)
}

export const getProjectCost = () => {
  const url = `${API_ROOT}/dashboard/project/status/budget/all`
  return doGet(url)
}

export const getScrutinize = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/scrutinize/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}

export const getDept6Scrutinize = (pagesize, pagenumber, projectcode, projectname, reviewType) => {
  const url = `${API_ROOT}/dashboard/project/status/scrutinize/dept6/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}&reviewtype=${reviewType || ''}`
  return doGet(url)
}

export const getScrutinizeExpert = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/dashboard/scrutinize/expert/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`

  return doGet(url)
}

export const getStatusProposalProject = (pagesize, pagenumber) => {
  // const url = `${API_ROOT}/dashboard/project/status/proposal/pagesize/${pagesize}/pagenumber/${pagenumber}`

  const url = `${API_ROOT}/dashboard/project/status/proposal/group/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const getStatusOngoingProject = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/dashboard/project/status/ongoing/pagesize/${pagesize}/pagenumber/${pagenumber}`

  // const url = `${API_ROOT}/dashboard/project/status/ongoing/group/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const getProjectStatusPending = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/dashboard/project/status/pending/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const searchProjectStatusPending = (pagesize, pagenumber, status) => {
  const url = `${API_ROOT}/dashboard/project/status/pending/filter/${status}/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const getAllProject = (pagesize, pagenumber) => {
  const url = `${API_ROOT}/dashboard/project/list/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doGet(url)
}

export const searchAllProject = (
  pagesize,
  pagenumber,
  projectcode,
  projectname,
  contractno,
  projectStatus,
  projectDepartment,
  showMyProject
) => {
  // http://103.91.191.229:9000/api/dashboard/project/list/filter/pagesize/0/pagenumber/0?projectcode=222&projectname=333
  const url = `${API_ROOT}/dashboard/project/list/filter/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}&contractno=${contractno || ''}&projectstatus=${
    projectStatus || ''
  }&projectdepartment=${projectDepartment || ''}&showmyproject=${showMyProject || 0}`
  return doGet(url)
}

export const getContractStatusWait = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/contract/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`

  return doGet(url)
}

export const getContractChange = (pagesize, pagenumber, projectcode, projectname) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/dashboard/project/contract-change/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`

  return doGet(url)
}

export const getWaitForReviewer = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/scrutinize/academic/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}

export const getExpertWaitScrutinizeApproval = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/scrutinize/expert/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}

export const getWaitApproval = (pagesize, pagenumber, projectcode, projectname, approveType) => {
  // const url = `http://localhost:9011/api/dashboard/project/waittingapprove/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
  const url = `${API_ROOT}/dashboard/project/waittingapprove/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}&approveType=${approveType || ''}`

  return doGet(url)
}

export const getWaitScreening = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/screening/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}
export const getWaitScreeningDepartment6 = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/screening/department6/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}
export const getWaitInitialScreening = (pagesize, pagenumber, projectcode, projectname) => {
  const url = `${API_ROOT}/dashboard/project/status/initial-screening/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}`
  return doGet(url)
}

// ---------------------------------- subproject
export const getSubProjectMain = (pagesize, pagenumber) => {
  // var API_ROOT = 'http://localhost:9012/api'
  const url = `${API_ROOT}/subproject/dashboard/${pagesize}/pagesize/${pagenumber}`
  return doGet(url)
}

export const searchSubProjectMain = (pagesize, pagenumber, code, name, year) => {
  const url = `${API_ROOT}/subproject/dashboard/${pagesize}/pagesize/${pagenumber}?code=${code}&name=${name}&year=${year}`
  return doGet(url)
}

export const getListInSubProject = (pagesize, pagenumber, mainProjectId) => {
  const url = `${API_ROOT}/subproject/${mainProjectId}/dashboard/${pagesize}/pagesize/${pagenumber}`
  return doGet(url)
}

export const searchListInSubProject = (pagesize, pagenumber, mainProjectId, code, name, status) => {
  const url = `${API_ROOT}/subproject/${mainProjectId}/dashboard/${pagesize}/pagesize/${pagenumber}?code=${code}&name=${name}&status=${status}`
  return doGet(url)
}

export const createSubProjects = (id, request) => {
  const url = `${API_ROOT}/subproject/${id}/project`
  return doPost(url, request)
}

export const getNotification = () => {
  const url = `${API_ROOT}/dashboard/project/notification`
  return doGet(url)
}

export const getProjectchart1 = (budgetYear) => {
  let url = `${API_ROOT}/dashboard/project/projectchart1`

  if (budgetYear) {
    url += `?budgetYear=${budgetYear}`
  }

  return doGet(url)
}

export const getProjectTableView = (budgetYear, pagesize, pagenumber) => {
  let url = `${API_ROOT}/dashboard/project/projectTableView/pagesize/${pagesize}/pagenumber/${pagenumber}`

  if (budgetYear) {
    url += `?budgetYear=${budgetYear}`
  }

  return doGet(url)
}

export const getProjectbudgetdisbursement = () => {
  const url = `${API_ROOT}/dashboard/project/projectbudgetdisbursement`
  return doGet(url)
}

// ----------------------------------
export const getDashboardSchemaPage = () => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/dashboard/page`
  // const url = `http://localhost:9011/api/dashboard/page`
  return doGet(url)
}

export const getWaitingContracterReview = (
  pagesize,
  pagenumber,
  projectcode,
  projectname,
  departmanet,
  projecttype
) => {
  const url = `${API_ROOT}/dashboard/project/waitingcontracterreview/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}&departmanet=${departmanet || ''}&projecttype=${
    projecttype || ''
  }`
  return doGet(url)
}

export const getWaitReviewToClose = (
  pagesize,
  pagenumber,
  projectcode,
  projectname,
  departmanet,
  projecttype
) => {
  const url = `${API_ROOT}/dashboard/project/waittingreviewtoclose/pagesize/${pagesize}/pagenumber/${pagenumber}?projectcode=${
    projectcode || ''
  }&projectname=${projectname || ''}&departmanet=${departmanet || ''}&projecttype=${
    projecttype || ''
  }`
  return doGet(url)
}

export const getDashboard = () => {
  const url = `${API_ROOT}/v1/accounting/dashboard/widget`
  return doGet(url)
}

export const getAllProjectAcc = (pagenumber, pagesize) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/allproject/${pagenumber}/${pagesize}`
  return doGet(url)
}

export const searchWarningDetail = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/warning-detail/search`
  return doPost(url, request)
}

export const saveWarningDetail = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/warning-detail/save`
  return doPost(url, request)
}

export const searchAllProjectAcc = (pagenumber, pagesize, request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/allproject/search/${pagenumber}/${pagesize}`
  return doPost(url, request)
}

export const searchProjectBudgetSummary = (request) => {
  const url = `${API_ROOT}/v1/accounting/project-budget/summary`
  return doPost(url, request)
}

export const searchSummaryBudgetCost = (request) => {
  // /api/v1/accounting/project-budget/summary/by-project
  const url = `${API_ROOT}/v1/accounting/project-budget/summary/by-project`
  return doPost(url, request)
}

// New Dashboard
export const getUpDownStremWidget = () => {
  const url = `${API_ROOT}/dashboard/coodinator/overview`
  // const url = `http://localhost:9011/api/dashboard/coodinator/overview`
  return doGet(url)
}

export const searchUpDownStremWidget = (request) => {
  const url = `${API_ROOT}/dashboard/coodinator/overview`
  // const url = `http://localhost:9011/api/dashboard/coodinator/overview`
  return doPost(url, request)
}

export const getUserOverviewWidget = () => {
  const url = `${API_ROOT}/dashboard/user/overview`
  // const url = `http://localhost:9011/api/dashboard/user/overview`
  return doGet(url)
}

//Setting Dashboard
export const getDashboardSetting = () => {
  const url = `${API_ROOT}/dashboard/page-setting`
  // const url = `http://localhost:9011/api/dashboard/page-setting`
  return doGet(url)
}

export const SaveDashboardSetting = (request) => {
  const url = `${API_ROOT}/dashboard/page-setting`
  // const url = `http://localhost:9011/api/dashboard/page-setting`
  return doPut(url, request)
}

export const getDashboardProjectBudgetReport = (request, masterkey, key) => {
  // const API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/dashboard/project-budget-report-view?masterkey=${
    masterkey || ''
  }&key=${key || ''}`

  return doPost(url, request)
}

export const downloadDashboardProjectBudgetReport = (request, masterkey, key) => {
  // const API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/download/project-budget-report-download?masterkey=${
    masterkey || ''
  }&key=${key || ''}`

  return doPostDownload(url, request)
}

// SubProject New Dashboard
export const getSubProjectCounterSummary = () => {
  // var API_ROOT = 'http://localhost:9012/api'
  const url = `${API_ROOT}/subproject/dashboard/summary-status-tracking`
  return doGet(url)
}

export const getSubProjectCounterSummaryDetail = (request) => {
  // var API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/dashboard/subproject/summary-status-tracking/detail-view`
  return doPost(url, request)
}

export const downloadSubProjectCounterSummaryDetail = (request) => {
  // var API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/dashboard/subproject/summary-status-tracking/detail-download`
  return doPostDownload(url, request)
}

export const getUpDownStreamContractWidget = () => {
  // var API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/dashboard/contract/overview`
  return doGet(url)
}

export const getDashboardProjectContractReport = (request, masterkey, key) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/files/dashboard/project-contract-report?masterkey=${
    masterkey || ''
  }&key=${key || ''}`

  return doPost(url, request)
}

export const downloadDashboardProjectContractReport = (request, masterkey, key) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/files/download/project-contract-report-download?masterkey=${
    masterkey || ''
  }&key=${key || ''}`

  return doPostDownload(url, request)
}

export const getAllProjectAssetClose = (pagenumber, pagesize) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/allproject/${pagenumber}/${pagesize}`
  return doGet(url)
}
export const searchAllProjectAssetClose = (pagenumber, pagesize, request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/accounting/allproject/search/${pagenumber}/${pagesize}`
  return doPost(url, request)
}
